module.exports = __webpack_public_path__ + "img/caret-right-square.300096b3.svg";